import icons from "../../icons/timeline/asset";
import TimelineItemIcon from "../../timeline/itemIcon";

export default function AssetTimelineItemIcon({ name }) {
  return <TimelineItemIcon icons={icons} name={name} />;
}
